// src/features/MediaLibrary/GlobalAudioManager.js
class GlobalAudioManager {
  constructor() {
    this.currentlyPlaying = null;
    this.registeredPlayers = new Map();
    this.initialized = false;
    this.init();
  }

  init() {
    if (this.initialized) return;
    
    window.addEventListener('beforeunload', () => this.stopAll());
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stopAll();
    });

    // REMOVED: history.pushState / replaceState patching — it conflicts with React Router
    
    this.initialized = true;
  }

  register(playerId, stopCallback) {
    if (!playerId || !stopCallback) return false;
    this.registeredPlayers.set(playerId, stopCallback);
    return true;
  }

  unregister(playerId) {
    if (!playerId) return;
    if (this.currentlyPlaying === playerId) {
      this.currentlyPlaying = null;
    }
    this.registeredPlayers.delete(playerId);
  }

  onPlay(playerId) {
    if (!playerId) return;
    this.registeredPlayers.forEach((stopCallback, id) => {
      if (id !== playerId) {
        try { stopCallback(); } catch (error) {
          console.warn(`Error stopping player ${id}:`, error);
        }
      }
    });
    this.currentlyPlaying = playerId;
  }

  onStop(playerId) {
    if (this.currentlyPlaying === playerId) {
      this.currentlyPlaying = null;
    }
  }

  stopAll() {
    this.registeredPlayers.forEach((stopCallback, id) => {
      try { stopCallback(); } catch (error) {
        console.warn(`Error stopping player ${id}:`, error);
      }
    });
    const audioElements = document.querySelectorAll('audio');
    audioElements.forEach(audio => {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
    this.currentlyPlaying = null;
  }

  getStatus() {
    return {
      currentlyPlaying: this.currentlyPlaying,
      totalRegistered: this.registeredPlayers.size
    };
  }
}

const globalAudioManager = new GlobalAudioManager();
export default globalAudioManager;